// extracted by mini-css-extract-plugin
export var navbarSubLink = "D_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "D_tQ d_f0 d_dB";
export var subPageLink = "D_gf d_gf";
export var burger = "D_vd";
export var sublinkSize = "D_vf";
export var linkSize = "D_vg";
export var Link = "D_rt q_rt q_qH q_q1";